export default "__VITE_PUBLIC_ASSET__49a85502__"